import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

export const useSaleListingAgreementReportStore = (ownerResourceId) => {
  const path = `sale-listing-agreements/${ownerResourceId}/reports/sale-listing-agreements`;
  const storeName = "saleListingAgreementReport" + ownerResourceId;
  return defineStore(storeName, () => {
    const all = ref([]);
    const { baseFetchAll, watchRemoteResourceChange } = useBase();

    const fetchAll = async (errorCallback) => {
      all.value = await baseFetchAll(path, errorCallback);
    };

    const watchResourceChanges = async (callback) => {
      await watchRemoteResourceChange(storeName, callback);
    };

    return {
      all,
      fetchAll,
      watchResourceChanges
    };
  })();
};
